// src/components/Admin/AdminDashboard.js
"use client";

import { useEffect, useState } from "react";
import { Row, Col, Card, Spinner } from "react-bootstrap";
import api from "../../services/api";

const AdminDashboardComp = () => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const { data } = await api.get("/admin/summary");
        setSummary(data);
      } catch (err) {
        console.error("Error loading admin summary:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSummary();
  }, []);

  if (loading) return <Spinner animation="border" className="d-block m-auto mt-5" />;

  return (
    <>
      <Card className="bg-white border-0 rounded-3 mb-4">
        <Card.Body className="p-4">
          
          <Row className="mb-4">
            <Col md={3}>
              <Card className="text-center">
                <Card.Body>
                  <h5>کاربران</h5>
                  <h3>{summary.users}</h3>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="text-center">
                <Card.Body>
                  <h5>فروشگاه‌ها</h5>
                  <h3>{summary.stores}</h3>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="text-center">
                <Card.Body>
                  <h5>دسته‌ها</h5>
                  <h3>{summary.categories}</h3>
                </Card.Body>
              </Card>
            </Col>
            <Col md={3}>
              <Card className="text-center">
                <Card.Body>
                  <h5>تراکنش‌ها</h5>
                  <h3>{summary.transactions}</h3>
                </Card.Body>
              </Card>
            </Col>
          </Row>

        </Card.Body>
      </Card>
    </>
  );
};

export default AdminDashboardComp;
